import(/* webpackMode: "eager", webpackExports: ["default"] */ "/var/lib/jenkins/workspace/Homework_web_ol/next-bee-website/src/app/components/Message/index.tsx");
;
import(/* webpackMode: "eager" */ "/var/lib/jenkins/workspace/Homework_web_ol/next-bee-website/src/app/globals.css");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/var/lib/jenkins/workspace/Homework_web_ol/next-bee-website/src/components/Footer/index.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/var/lib/jenkins/workspace/Homework_web_ol/next-bee-website/src/components/NavBar/index.tsx");
